// document.addEventListener("DOMContentLoaded", () => {
    const swatches = document.querySelectorAll('.make-a-set-container .bundle-swatches-groups .pdp__swatches .color-swatch');
    const bundleAtcs = document.querySelectorAll(".make-a-set-container .bundle-atc");
    bundleAtcs.forEach((bundleAtc) => {
        bundleAtc.addEventListener('click', async () => bundleAtcAction(bundleAtc));
    })

    swatches.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
            const color = swatch.getAttribute('data-value');
            const colorGroup = calpak.getColorGroup(color);
            const productUnits = swatch.closest(".make-a-set-container")?.querySelectorAll(".bundle-items .product-unit");
            productUnits.forEach(productUnit => {
                const match = getProductUnitColorMatch(productUnit, color, colorGroup, false);
                if(match) {
                    let newSwatch = productUnit.querySelector(`.color-swatch[data-value="${match.getAttribute('data-option1')}"]`);

                    const activeFirst = productUnit.querySelector('.color-swatch--first');
                    if(activeFirst) activeFirst.classList.remove('color-swatch--first');

                    newSwatch?.classList.add('color-swatch--first');
                    newSwatch?.click();
                }
            });

        });
    });

    function getProductUnitColorMatch(productUnit, color, colorGroup, onlyAvailable = true) {
        let match = false, backupMatch = false;
    
        const productUnitOptions = productUnit.querySelectorAll('.variant-select option');
        for(let i = 0; i < productUnitOptions.length; i++) {
            let singleOption = productUnitOptions[i];
            const available = singleOption.getAttribute('data-available');
            const optionColor = singleOption.getAttribute('data-option1');
    
            if(color === optionColor) {
                if(!onlyAvailable || available == 'true') {
                    match = singleOption;
                    break;
                } else {
                    backupMatch = singleOption;
                }
            } else if(match === false && available == 'true' && colorGroup.colors.indexOf(optionColor) > -1) match = singleOption;
        }
    
        if(match === false && backupMatch !== false) match = backupMatch;
    
        return match;
    }

    const bundleAtcAction = async (bundleAtc) => {
        const bundleContainer = bundleAtc.closest('.make-a-set-container');
        if (!bundleContainer) {
          console.error('Bundle container not found');
          return;
        }
        if(!bundleContainer.classList.contains('free-gift-container')){
            const activeSwatch = bundleContainer.querySelector('.bundle-swatches-groups.swatches-container .color-swatch.color-swatch--active:not(.product-option--na)');
            if (!activeSwatch) {
              console.error('No active color swatch found');
              return;
            }
        
            const variantId = activeSwatch.getAttribute('data-variant-id');
            if (!variantId) {
              console.error('Bundle variant ID not found');
              return;
            }
        
            bundleAtc.classList.add('adding-to-cart');
    
            calpak.addToCart(variantId, 1, (data) => {
                calpak.updateCart(data);
                calpak.openCart();
    
                if (bundleAtc) {
                    bundleAtc.classList.remove('adding-to-cart');
                    bundleAtc.classList.add('added-to-cart');
            
                    setTimeout(() => {
                        bundleAtc.classList.remove('added-to-cart');
                    }, 3000);
                }
            });
        }
        else{
            const activeSwatches = bundleContainer.querySelectorAll('.bundle-items .product-unit .color-swatch.color-swatch--active:not(.product-option--na)');

            let variantItems = [];
            activeSwatches.forEach(swatch=>{
                const variantId = swatch.getAttribute('data-first-variant-id');
                if (!variantId) {
                    console.error('Bundle variant ID not found');
                    return;
                }
                variantItems.push({variantId: variantId, quantity: 1});
            })

            bundleAtc.classList.add('adding-to-cart');
    
            calpak.addMultiItemsToCart(variantItems, (data) => {
                calpak.updateCart(data);
                calpak.openCart();
    
                if (bundleAtc) {
                    bundleAtc.classList.remove('adding-to-cart');
                    bundleAtc.classList.add('added-to-cart');
            
                    setTimeout(() => {
                        bundleAtc.classList.remove('added-to-cart');
                    }, 3000);
                }
            });
        }
    }

//})

